module.exports = __webpack_public_path__ + "static/media/circle_winds.88977e57.png";